import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import HeroSection from "../components/Home/HeroSection";
import BlockAboutOne from "../components/About/BlockAboutOne";
import Values from "../components/About/Values";
import Directories from "../components/Home/Directories";
import BlockHomeOne from "../components/Home/BlockHomeOne";
import FormHome from "../components/Home/FormHome";
import Map from "../components/Contact/MapContent";
import Modal from "../components/Home/Modal";
import BaseLayout from "../components/global/BaseLayout";
import ServicesBlock from '../components/Home/ServicesBlock_2'
import BlockHomeTwo from "../components/Home/BlockHomeTwo";

function Home() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Home">
      <div className="md:max-w-full w-full">
        <Modal />
        <HeroSection />
        <BlockHomeOne />
        <Directories />
        <BlockAboutOne />
        <div className="mt-[10px]">
          <Values />
        </div> 
        <BlockHomeTwo/>
        <ServicesBlock/>
        {/* <ServicesHome /> */}
        <div className="py-[100px]" style={{ backgroundImage: `url("${rpdata?.gallery?.[5]}")` }}>
          <FormHome />
        </div>
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Home;
